module.exports = "<div style=\"border: 1px solid red\">detail-faq-category Component</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/faq-components/detail-faq-category/detail-faq-category.component.html
// module id = ./src/app/faq-components/detail-faq-category/detail-faq-category.component.html
// module chunks = main